import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { FiInfo } from 'react-icons/fi';
import { Counter, LikeButton, RegVideo, Video } from '../components/Complete';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <section className="mdx-page">
      <div className='mdx-img'>
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "650px"
            }
          }}>{`
      `}<a parentName="span" {...{
              "className": "gatsby-resp-image-link",
              "href": "/static/09546b472d4d1fec99dc388ea242d2bd/21b4d/gatsby-1.png",
              "style": {
                "display": "block"
              },
              "target": "_blank",
              "rel": "noopener"
            }}>{`
    `}<span parentName="a" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "56.44171779141104%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC/0lEQVQozz3Ta0yTZxjG8Vf3UZ1RPGA5FFoKES1iU6fgpKVlJvNsWBnaKZNIO4tNxPOmaDJQY8yWmWWSqDFixcCSeZ7LImwRhVEKrT0BbVHAghUmyGHx6395X6Mf7uT59Mt95XpuoaqqCrvdTnFxMQUFBWi1WjIyMkiRp5AkTyTfoKfySBUhfx+hSDcNFx+yeHoR21cfp/tpH57WEMHO52xSHyBnXimCzWbDZDJhMBjQaDSkp6dLWFq6gspD1dy50Ia3MUrr3R6aHH7OVdxgh/4EflcvXmeEHl8/X2iPsGJ2CfpEK0JhYSF6vZ7s7GxUKhVKhZKEJBmH9x3HeaufVwNvGBl6w+vYBK9fTvB3fYCAsx9/Zy/hwAt26E6g/Xgn+UnfsGZRGYJOpyMrK4u0tDQUCgXyZDka7XJuX3xM7Pk4L8IjBP4ZkEZ8j0THaazz0hceouzzU2hmfkV+8jssT2ZBUKvVKJVKUlNTpbhx8+LY9qWZRw1djA1PEfYMUXuqiZqjD+h2RZkaf0vzb0GO7vyZ5TPM5CfvkbAP4HtMjLtgwUKMRiOhnggPHV5GX00SaBvg3uV2bl5oxd/az+TYW/6q97Fr7UmpBF2C9QNmkO9BeI/Fx8eTm5uLz+vDF/Tg+jNMxB1jfPQ/nvlj0owOTzAYHuNmTTPr1HtZPX+3BIljTLGxYUkFgojJZDKpYbfbQ6fHhdsZ4NxhB7/+1EywZZB/BycZjU3R6x6mse4pFeazrJz7tbSdiBWk2ti4dD/FOd8hiFhmZiZOZzsdne2EunopNVajErZyy9HEH9fbeHDVyd1LLVw5c49yUzWr5peQt8hCXoKFzxTl0h/clntMKkkqpeVJCx0dLroCIexbfmDJR0Vc/fE+ka4oPcFn1JypZ2O2HaOqjE/mlJAns6JLtLJWuZfNyw5i/rQS6/rTHDKfRxAvpLa2lsGhKGf3O1g8zURRzrdc++V32h8FaWsKoJ1Vwqq4UtbEW6SYOnEzEcs6IF2MZd1pDm4/z/fll/kfW+QWBy7dMH4AAAAASUVORK5CYII=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="a" {...{
                "className": "gatsby-resp-image-image",
                "alt": "nice image",
                "title": "nice image",
                "src": "/static/09546b472d4d1fec99dc388ea242d2bd/a6d36/gatsby-1.png",
                "srcSet": ["/static/09546b472d4d1fec99dc388ea242d2bd/222b7/gatsby-1.png 163w", "/static/09546b472d4d1fec99dc388ea242d2bd/ff46a/gatsby-1.png 325w", "/static/09546b472d4d1fec99dc388ea242d2bd/a6d36/gatsby-1.png 650w", "/static/09546b472d4d1fec99dc388ea242d2bd/e548f/gatsby-1.png 975w", "/static/09546b472d4d1fec99dc388ea242d2bd/21b4d/gatsby-1.png 1280w"],
                "sizes": "(max-width: 650px) 100vw, 650px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
  `}</a>{`
    `}</span></p>
      </div>
      <h2>{`My first mdx file`}</h2>
      <p><strong parentName="p">{`I'm baby hashtag tofu gluten-free flannel umami 90's heirloom letterpress. 3 wolf moon scenester chartreuse`}</strong>{`blue bottle coloring book live-edge marfa blog fingerstache ugh. Chia whatever street art cray art party locavore pitchfork chambray salvia freegan schlitz. Kombucha mixtape tattooed church-key meditation jianbing tote bag pitchfork fanny pack listicle plaid edison `}<em parentName="p">{`bulb four loko ramps. Synth ethical butcher, retro plaid shabby chic bitters activated charcoal. Cornhole pickled cardigan williamsburg hexagons`}</em></p>
      <h1>{`my heading h1`}</h1>
      <h4>{`my another heading`}</h4>
      <div className='code'>
        <pre><code parentName="pre" {...{
            "className": "language-js"
          }}>{`const firstName = 'john'
const lastName = 'smith'
`}</code></pre>
      </div>
      <div className='nice-text'>
        <h3>nice text</h3>
        <FiInfo className="nice-text-icon" mdxType="FiInfo"></FiInfo>
        <p>{`Lorem ipsum dolor sit amet consectetur adipisicing elit. Modi expedita, nihil iste voluptas a magnam similique iure! Sapiente tenetur nostrum assumenda, saepe pariatur quaerat nobis ab, distinctio perferendis consequatur quasi!`}</p>
      </div>
      <h2>React Components</h2>
      <Counter mdxType="Counter" />
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react'
import styled from 'styled-components'
import { AiOutlineLike } from 'react-icons/ai'
const LikeButton = () => {
  const [value, setValue] = React.useState(0)
  return (
    <Wrapper>
      <div>
        <button onClick={() => setValue(value + 1)}>
          <AiOutlineLike />
        </button>
        <p>
          Liked the post?
          <br />
          Click thumbs up few times
        </p>
      </div>
      <span>+{value}</span>
    </Wrapper>
  )
}
`}</code></pre>
      <LikeButton mdxType="LikeButton" />
      <h2>video componentes</h2>
      <RegVideo mdxType="RegVideo" />
      <Video mdxType="Video" />
      <h2>regular heading</h2>
      <h2 title="true">title heading</h2>
      <h4>inline code</h4>
      <p><inlineCode parentName="p">{`console.log('hello there')`}</inlineCode></p>
      <h4>blockquote element</h4>
      <blockquote display="default">Lorem ipsum dolor sit amet.</blockquote>
      <blockquote display="info">Lorem ipsum dolor sit amet.</blockquote>
      <blockquote display="warning">Lorem ipsum dolor sit amet.</blockquote>
      <blockquote>
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Perferendis amet
  expedita temporibus excepturi odio voluptate corrupti non? Incidunt
  reprehenderit, sed iste aperiam necessitatibus quos error velit, consectetur
  amet, tenetur nesciunt!
      </blockquote>
      <h4>{`Javascript`}</h4>
      <pre><code parentName="pre" {...{
          "className": "language-js"
        }}>{`// comments
const name = 'john'
const channel = 'coding addict'

function featuredProducts(data) {
  return data.filter(item => {
    return item.featured === true
  })
}
featuredProducts()
`}</code></pre>
      <h4>{`JSX`}</h4>
      <pre><code parentName="pre" {...{
          "className": "language-jsx"
        }}>{`import React from 'react'

const Counter = () => {
  const [count, setCount] = React.useState(0)
  return (
    <section className="counter">
      <h4>show some love to MDX</h4>
      <h4>likes {count}</h4>
      <button className="btn btn-danger" onClick={() => setCount(count + 1)}>
        i like mdx
      </button>
    </section>
  )
}
export default Counter
`}</code></pre>
      <h4>{`HTML`}</h4>
      <pre><code parentName="pre" {...{
          "className": "language-html"
        }}>{`<h1>hello world</h1>
<p class="random">random text</p>
<section class="contact">
  <div class="title">
    <h1>contact us</h1>
  </div>
</section>
`}</code></pre>
      <h4>{`CSS`}</h4>
      <pre><code parentName="pre" {...{
          "className": "language-css"
        }}>{`max-width: 500px;
border-radius: var(--radius);
padding: 1rem 1.5rem;
background: var(--clr-grey-10);
text-align: center;
`}</code></pre>
      <Link to="/posts" className="btn center-btn" mdxType="Link">
  all posts
      </Link>
    </section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      